import { useTranslation } from "react-i18next";
import { numberWithCommas } from "../../utils/functions";
import { BsInfoCircleFill } from "react-icons/bs";
import "./FeeBreakdownModal.css";

interface FeeBreakdownModalProps {
    ticker: string;
    amount: number;
    fee: number;
    minFee?: number;
    decimals?: number;
}

const FeeBreakdownModal = ({
    ticker,
    amount,
    fee = 0,
    minFee = 0,
    decimals = 8,
}: FeeBreakdownModalProps) => {
    const { t } = useTranslation('common');
    const appliedFee = Math.max(minFee, amount * fee);
    const amountToReceive = amount - appliedFee;

    return (
        <div className="fee-breakdown-modal">
            <div className="fee-breakdown-title">{t("fee_breakdown")}</div>

            <div className="fee-breakdown-content">
                <div className="fee-breakdown-row">
                    <span className="breakdown-label">{t("amount")}:</span>
                    <span className="breakdown-value">
                        {numberWithCommas(amount, decimals)} {ticker}
                    </span>
                </div>


                <div className="fee-breakdown-row">
                    <span className="breakdown-label">{t("fee_deducted")}:</span>
                    <span className="breakdown-value negative">
                        - {numberWithCommas(appliedFee, decimals)} {ticker}
                    </span>
                </div>

                <div className="fee-breakdown-divider" />

                <div className="fee-breakdown-row total">
                    <span className="breakdown-label">{t("amount_to_receive")}:</span>
                    <span className="breakdown-value">
                        {numberWithCommas(amountToReceive, decimals)} {ticker}
                    </span>
                </div>
            </div>

            <div className="fee-breakdown-note">
                <BsInfoCircleFill className="note-icon" />
                <span>{t("fee_note")}</span>
            </div>
        </div>
    );
};

export default FeeBreakdownModal;